<template>
  <Echart id="major-shareholders-pie" :chartData="chartShareholderData" />
</template>

<script setup>
import { computed, ref, defineAsyncComponent, onMounted } from "vue";
import { useRoute } from "vue-router";

const parsedTableData = ref([]);
const route = useRoute();

const Echart = defineAsyncComponent(() =>
  import(`@/components/apps/chart/Pie.vue`)
);

onMounted(() => {
  const tableElement = document.getElementById("shareholderTableRef");
  if (tableElement) {
    try {
      parsedTableData.value = parseShareholderTable(tableElement);
    } catch (error) {
      console.error("Error parsing shareholder table:", error);
    }
  } else {
    console.error("Shareholder table element ref not found!");
  }
});

function parseShareholderTable(tableElement) {
  const data = []
  const rows = tableElement.querySelectorAll('tbody tr')
  let currentGroup = null

  rows.forEach((row) => {
    const cells = row.querySelectorAll('td')
    if (cells.length < 4) return

    const rankText = cells[0].textContent.trim()
    const name = cells[1].textContent.trim()
    const percentText = cells[3].textContent.trim()
    const percent = parseFloat(percentText)

    if (name.toUpperCase() === 'TOTAL' || isNaN(percent)) return

    const hasValidRank = rankText !== '' && rankText !== '\u00a0'

    if (hasValidRank) {
      if (currentGroup) data.push(currentGroup)
      const rank = parseInt(rankText, 10)
      currentGroup = {
        id: name.toLowerCase().replace(/[^a-z0-9]/g, '') + rank,
        name,
        percent,
        totalPercent: percent,
        rank,
        subNames: [], // ← เพิ่ม
      }
    } else if (currentGroup) {
      currentGroup.totalPercent = parseFloat(
        (currentGroup.totalPercent + percent).toFixed(3)
      )
      currentGroup.subNames.push({ name, percent }) // ← เพิ่ม
    }
  })

  if (currentGroup) data.push(currentGroup)
  return data
}

const chartShareholderData = computed(() => {
  const seriesName = route.path.startsWith('/th') ? 'Major Shareholders' : 'Major Shareholders';
  const defaultChartData = {
    id: "major-shareholders",
    series1: {
      name: seriesName,
      data: [],
      unit: "%"
    }
  };

  if (parsedTableData.value.length === 0) {
    return defaultChartData;
  }

  const topNumber = parsedTableData.value.filter(
    group => group.rank !== null && group.rank <= 5
  );

  let topSlices = topNumber.map(group => ({
    name: group.name,
    value: parseFloat(group.totalPercent.toFixed(3)),
    percent: group.percent,
    subNames: group.subNames,
}))

  topSlices.sort((a, b) => b.value - a.value);

  const topPrimaryPercentSum = topNumber.reduce(
    (sum, group) => sum + group.totalPercent, 0
  );
  const othersPercent = parseFloat((100 - topPrimaryPercentSum).toFixed(3));

  const othersLabel = route.path.startsWith('/th') ? 'อื่นๆ' : 'Others';

  let finalChartSlices = [...topSlices];

  if (othersPercent > 0.001) {
    finalChartSlices.push({ name: othersLabel, value: othersPercent });
  }

  return {
    id: "major-shareholders",
    series1: {
      name: seriesName,
      data: finalChartSlices,
      unit: "%"
    }
  };
});
</script>